import {ServerDocumentEditorLock} from 'notebook/realtime/DocumentEditorLockConstants';
import {DocumentUpdateNotification} from 'notebook/realtime/DocumentUpdateNotifications';

// Keep in sync with benchling/notebook/realtime/publish_document_updates.py
export enum DocumentUpdateMessageTypes {
  ENTRY_UPDATE = 'entry_update',
  LOCK_UPDATE = 'lock_update',
}
export interface DocumentUpdateData {
  clientId: string;
  userNotifications?: Array<DocumentUpdateNotification>;
  lock?: ServerDocumentEditorLock;
}
